var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "google-pay-method" }, [
    _vm.googlePriceOld || _vm.googlePrice
      ? _c(
          "div",
          {
            staticClass: "method",
            class: { noClick: _vm.loadingShow },
            on: { click: _vm.handleGooglePay },
          },
          [
            _c("div", { staticClass: "methods" }, [
              _vm._m(0),
              _c("div", { staticClass: "line" }),
              _c("div", { staticClass: "method-name" }, [
                _c("span", [_vm._v("Google Pay")]),
                _c("div", { staticClass: "rate" }, [
                  _vm.googlePriceOld
                    ? _c(
                        "div",
                        {
                          staticClass: "pay-price",
                          style: { width: _vm.longestWidth + "px" },
                        },
                        [_c("span", [_vm._v(_vm._s(_vm.googlePriceOld))])]
                      )
                    : _vm._e(),
                  _vm.googlePrice
                    ? _c(
                        "div",
                        {
                          staticClass: "pay-price",
                          style: { width: _vm.longestWidth + "px" },
                        },
                        [
                          _c("i", [_vm._v(_vm._s(_vm.currency))]),
                          _c("span", [_vm._v(_vm._s(_vm.googlePrice))]),
                        ]
                      )
                    : _vm._e(),
                ]),
              ]),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "method-img" }, [
      _c("img", {
        attrs: {
          src: require("@/assets/packageAssets/common/google.png"),
          alt: "",
        },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }